import type { RolePermission as RolePermissionModel } from '@/adapters/catalogv1.g';

export function extractRolePermission(model: RolePermissionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    roleRef: model.role_ref ?? '',
    permissionRef: model.permission_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogRolePermission = ReturnType<typeof extractRolePermission>;
